import { render } from "./FuelingTransactionRevision.vue?vue&type=template&id=d52b8652&ts=true"
import script from "./FuelingTransactionRevision.vue?vue&type=script&lang=ts"
export * from "./FuelingTransactionRevision.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__